/*=============================================
|          FORM VALIDATIONS                   |
=============================================*/
pedidoValidations = (field) => {
    const errors = []
    if (!field.$dirty) return errors
    !field.required && errors.push('El número de pedido es obligatorio')
    !field.minLength && errors.push('La longitud minima del número de pedido es inválido')
    !field.maxLength && errors.push('La longitud máxima del número de pedido es inválido')
    return errors
}

module.exports = {
    pedidoValidations
}